import { ChangeDetectorRef, Component, ElementRef,  Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthGuardService } from '../../services/auth-guard.service';
import { LauftextService } from '../../services/lauftext.service';
import { style, animate, AnimationBuilder, AnimationFactory, AnimationPlayer } from '@angular/animations';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
    selector: 'app-lauftext',
    templateUrl: './lauftext.component.html',
    styleUrls: ['./lauftext.component.scss'],
    standalone: false
})
export class LauftextComponent implements OnInit, OnDestroy {
    protected unsubscribe$ = new Subject();
    @ViewChild('el') el: ElementRef;

    lauftexts = [];
    lengtht: number = 0;
    media: string = 'xs';
    protected factory: AnimationFactory;

    player: AnimationPlayer;
    isBrowser: boolean = false;
    showText: boolean = false;
    isGoogle: boolean = false;
    constructor(
        protected router: Router,
        protected guardService: AuthGuardService,
        protected builder: AnimationBuilder,
        protected cdr: ChangeDetectorRef,
        protected lauftextService: LauftextService,
        protected mediaObserver: BreakpointObserver,
        @Inject(PLATFORM_ID) protected platformId: any,
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.isGoogle = this.detectChromTest() || this.detectRobot(navigator.userAgent);
            this.initMedia();
        }
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.media = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.media = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.media = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.media = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.media = 'xl';
        }
        this.cdr.detectChanges();
        this.initData();
    }

    async initData() {
        this.guardService.getPartnerid$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((partnerid: string) => {
            if (partnerid?.length > 0) {
                this.getLaufText(partnerid)
            }
        });
    }

    async getLaufText(partnerid) {
        this.lauftextService.request({ partnerid: partnerid }, 'getlauftexts').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((res) => {
            if (res?.length > 0) {
                this.lauftexts = res;
                this.lengtht = 0;
                for (let i = 0; i < this.lauftexts.length; i++) {
                    this.lengtht += this.measureText(this.lauftexts[i].text, 14);
                }
                if (this.lauftexts?.length > 0) {
                    this.startLauf();
                }
            }
        });
    }

    startLauf(): void {
        if (this.isBrowser) {
            let prc = 100;
            let speed = 150;
            setTimeout(() => {
                this.showText = true;
                if (this.el?.nativeElement?.clientWidth > 0) {
                    prc = ((this.lengtht + this.el.nativeElement.clientWidth) * 100 / this.el.nativeElement.clientWidth);
                    speed = this.el.nativeElement.clientWidth / 9;
                    this.factory = this.builder.build([
                        style({ right: '-100%' }),
                        animate(speed + 's', style({ right: prc + '%' }))
                    ]);
                    this.player = this.factory.create(this.el?.nativeElement, {});
                    this.animate();
                    this.cdr.detectChanges();
                }
            }, 100);
        }
    }

    async goto(nbr) {
        this.router.navigate([this.guardService.getPartnerId(), 'contents', nbr]);
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    private animate(): void {
        this.player.reset();

        this.player.onDone(() => {
            this.animate();
            this.cdr.detectChanges();
        });

        this.player.play();
    }

    measureText(pText, pFontSize) {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        ctx.font = pFontSize + 'px Arial'; // This can be set programmaticly from the element's font-style if desired
        const textWidth = ctx.measureText(pText).width;
        return textWidth;
    }

    detectRobot(userAgent: string): boolean {
        const robots = new RegExp(([
            /bot/, /spider/, /crawl/, // GENERAL TERMS
            /APIs-Google/, /AdsBot/, /Googlebot/, // GOOGLE ROBOTS
            /mediapartners/, /Google Favicon/, /GOOGLE/,
            /FeedFetcher/, /Google-Read-Aloud/,
            /DuplexWeb-Google/, /googleweblight/,
            /bing/, /yandex/, /baidu/, /duckduck/, /yahoo/, // OTHER ENGINES
            /ecosia/, /ia_archiver/, /cortex/,
            /facebook/, /instagram/, /pinterest/, /reddit/, // SOCIAL MEDIA
            /slack/, /twitter/, /whatsapp/, /Whatsapp/, /youtube/,
            /semrush/, // OTHER
        ] as RegExp[]).map((r) => r.source).join('|'), 'i'); // BUILD REGEXP + "i" FLAG

        return robots.test(userAgent);
    }

    detectChromTest(): boolean {
        if (navigator.userAgent.match(/(Mozilla\/5\.0 \(Linux; Android 11; moto g power \(2022\)\) AppleWebKit\/537\.36 \(KHTML, like Gecko\) Chrome\/109\.0.0.0 Mobile Safari\/537\.36)|(Mozilla\/5\.0 \(Macintosh; Intel Mac OS X 10_15_7\) AppleWebKit\/537\.36 \(KHTML, like Gecko\) Chrome\/109\.0\.0\.0 Safari\/537\.36)|(Speed Insights)|(Chrome-Lighthouse)/)) {
            return true;
        } else {
            return false;
        }
    }
}
